<template>
  <button class="shop-btn" @click="$emit('click')" type="button">
    <span class="shop-btn__icon">◇</span>
    <span class="shop-btn__text">Магазин</span>
  </button>
</template>

<script setup lang="ts">
defineEmits<{
  click: []
}>()
</script>

<style scoped>
.shop-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 999px;
  border: none;
  background: #6258D9;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(98, 88, 217, 0.22);
  white-space: nowrap;
  font-family: "Inter", system-ui, sans-serif;
  transition: transform 0.15s, box-shadow 0.15s;
}
.shop-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(98, 88, 217, 0.28);
}
.shop-btn__icon {
  font-size: 16px;
}
</style>
